'use strict'
const modal = {
	el: {
		btnsTriggerModal: document.querySelectorAll('.js-open-modal'),
		btnsCloseModal: document.querySelectorAll('.js-close-modal'),
		modal: document.querySelector('.js-modal'),
		body: document.body
	},

	fxRenderYoutubeVideo(event, btn, modal) {
		const videoSrc = btn.dataset.src,
			modalVideoContainer = modal.querySelector('.video__iframe-container')

		const videoIframe = document.createElement('div')

		videoIframe.classList.add('video__iframe', 'js-lazyframe', 'lazyframe')
		videoIframe.setAttribute('data-vendor', 'youtube')
		videoIframe.setAttribute('data-src', videoSrc)

		modalVideoContainer.append(videoIframe)

		lazyload.fxLazyFrame(videoIframe)
	},

	fxOpenModal(event, element) {
		const modalType = element.dataset.modal ? element.dataset.modal : 'gpf',
			modalContainer = document.querySelector(`.js-modal[data-modal='${modalType}']`)

		event.preventDefault()
		modalContainer.classList.add('open')

		//gpf modal
		if(modalType === 'gpf') {
			const tabs = modalContainer.querySelectorAll('.tab-content'),
				formContainer = modalContainer.querySelectorAll('.jq_tab-content'),
				forms = modalContainer.querySelectorAll('form')
	
			for (const form of forms) {
				form.reset()
			}
	
			tabs.forEach(el => {
				el.dataset.operation === element.dataset.tab ? el.classList.add('selected') : el.classList.remove('selected')
			})
	
			formContainer.forEach(el => {
				el.dataset.container === element.dataset.tab ? el.classList.remove('d-none') : el.classList.add('d-none')
			})
		}

		if(modalType === 'video') {
			videoHelper.fxSetupVideoPlayer(element)
		}

		if(modalType === 'youtube') {
			this.fxRenderYoutubeVideo(event, element, modalContainer)
		}
		
		!this.el.body.classList.contains('no-scroll-hidden') && this.el.body.classList.add('no-scroll-hidden')
	},

	fxCloseModal(element) {
		const modal = element.closest('.modal')
		
		modal.classList.remove('open')
		modal.classList?.remove('open-static')
		this.el.body.classList.remove('no-scroll-hidden')

		if(modal.dataset.modal === 'video') {
			const videoPlayer = modal.querySelector('video')
			
			// unload video on close
			videoHelper.fxUnloadVideo(videoPlayer)
		}
		if(modal.dataset.modal === 'youtube') {
			const iframe = modal.querySelector('.video__iframe')
			iframe.remove()
		}
	},

	events () {
		for(const btn of this.el.btnsTriggerModal) {
			btn.addEventListener('click', e => this.fxOpenModal(e, e.currentTarget))
		}

		for(const btn of this.el.btnsCloseModal) {
			btn.addEventListener('click', e => this.fxCloseModal(e.currentTarget))
		}
	},

	init () {
		if(this.el.btnsTriggerModal.length === 0 || !this.el.btnsCloseModal) return
		this.events()
	}
}

modal.init()